import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, Tooltip, IconButton, } from "@chakra-ui/react";
import MyDiv from "./bloodGroup.style";
import { CustomButton, CustomToast } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { IGroup } from "./model";
import CustomTables, { Column, ILazyParams } from "../../../../components/CustomTable/CustomTables";
import { EditIcon } from "@chakra-ui/icons";

const BloodGroup = () => {
    const [group, setGroup] = useState<IGroup[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [currentBloodGroup, setCurrentBloodGroup] = useState({ id: 0, blood_Group: "", });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);

    const [dataLoading, setDataLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0, rows: 20, sortField: undefined, sortOrder: undefined,
        multiSortMeta: [], filters: {}, globalFilter: '',
    });

    useEffect(() => {
        loadGroup();
    }, [lazyParams]);

    const loadGroup = async () => {
        setDataLoading(true);
        const params = new URLSearchParams();
        params.set('first', String(lazyParams.first));
        params.set('rows', String(lazyParams.rows));
        if (lazyParams.sortField) params.set('sortField', lazyParams.sortField);
        if (lazyParams.sortOrder) params.set('sortOrder', String(lazyParams.sortOrder));
        if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
        if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
            params.set('filters', JSON.stringify(lazyParams.filters));
        }

        const response = await fetchApi<any>(`Hrlense_BloodGroup?${params.toString()}`, "GET");
        if (response) {
            setGroup(response.data ?? response ?? []);
            setTotalCount(response.totalRecords ?? response.length ?? 0);
        }
        setDataLoading(false);
    };

    const handleAddNewBloodGroup = () => {
        setIsEditMode(false);
        setCurrentBloodGroup({ id: 0, blood_Group: "" });
        setSelectedId(null);
        setDrawerOpen(true);
    };

    const handleEditBloodGroup = (blood_Group: IGroup) => {
        setDrawerOpen(true);
        setIsEditMode(true);
        setSelectedId(blood_Group.id);
        setCurrentBloodGroup(blood_Group);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setCurrentBloodGroup((prev) => ({ ...prev, [name]: value, }));
    };

    const handleSubmit = async () => {
        if (!currentBloodGroup.blood_Group.trim()) {
            addToast({ message: "Please enter Blood Group", status: "warning" });
            return;
        }
        if (isEditMode) {
            const response = await fetchApi(`Hrlense_BloodGroup/${currentBloodGroup.id}`, "PUT", { id: currentBloodGroup.id, blood_Group: currentBloodGroup.blood_Group, }, null, "Blood Group updated successfully");
            if (response) await loadGroup();
        } else {
            const response = await fetchApi<IGroup>("Hrlense_BloodGroup", "POST", { blood_Group: currentBloodGroup.blood_Group, }, null, "Blood Group added successfully");
            if (response) await loadGroup();
        }
        setDrawerOpen(false);
    };

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                <>
                    <Flex className="page_heading flex_header">
                        <Text className="font-poppins text_semibold text_3xl">Blood Group List</Text>
                        <Flex gap={2}>
                            <CustomButton title="Add New BloodGroup" className=" btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewBloodGroup} />
                        </Flex>
                    </Flex>
                    <Grid className="grid_container">
                        <GridItem colSpan={12}>
                            <CustomTables<IGroup>
                             value={group} loading={dataLoading} emptyMessage="No Blood Groups Found" preferenceKey="bloodGroupTable"
                               lazy lazyParams={lazyParams} onLazyParamsChange={setLazyParams} totalRecords={totalCount} showGlobalSearch={false} showToolbar={true}
                                showPagination rowsPerPageOptions={[20, 100, 200, 500]} maxTableHeight={null}
                            >
                                <Column header="S. No" body={(_, index) => lazyParams.first + index + 1} />
                                <Column header="Blood Group" field="blood_Group" sortable filterable filterType="text" />
                                <Column header="Action" frozen="right" body={(emp: any) => (
                                        <Tooltip label="Edit Blood Group" hasArrow>
                                            <IconButton aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditBloodGroup(emp)} />
                                        </Tooltip>
                                    )}
                                />
                            </CustomTables>
                        </GridItem>
                    </Grid>
                    <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                        <DrawerOverlay />
                        <DrawerContent>
                            <DrawerCloseButton />
                            <DrawerHeader borderBottomWidth="1px">{isEditMode ? "Edit BloodGroup" : "Add New BloodGroup"}</DrawerHeader>
                            <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%" >
                                <Box py={4}>
                                    <FormControl mb={4} isRequired>
                                        <FormLabel>Blood Group</FormLabel>
                                        <Input name="blood_Group" value={currentBloodGroup.blood_Group} onChange={handleInputChange} placeholder="Enter Blood Group" />
                                    </FormControl>
                                </Box>
                                <Flex justify="flex-end" mt={4} gap={2}>
                                    <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}> Cancel
                                    </Button>
                                    <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }}> {isEditMode ? "Update BloodGroup" : "Add BloodGroup"}</Button>
                                </Flex>
                            </DrawerBody>
                        </DrawerContent>
                    </Drawer>
                </>
            </Box>
        </MyDiv>
    );
};
export default BloodGroup;